import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dlg-big-image',
  templateUrl: './dlg-big-image.component.html',
  styleUrls: ['./dlg-big-image.component.scss']
})
export class DlgBigImageComponent implements OnInit {
  image: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.image = data;
    console.log( this.image )
  }

  ngOnInit(): void {

  }

}
